export interface GlyphData {
    w: number;
    h: number;
    b: number[];
}

export const JP_FONT_DB: Record<number, GlyphData> = {
    12353: { w: 6, h: 6, b: [32, 120, 32, 120, 180, 100] }, // ぁ
    12354: { w: 7, h: 8, b: [32, 124, 32, 60, 106, 170, 178, 100] }, // あ
    12355: { w: 6, h: 5, b: [136, 132, 132, 160, 64] }, // ぃ
    12356: { w: 7, h: 7, b: [136, 132, 130, 130, 130, 160, 64] }, // い
    12357: { w: 5, h: 6, b: [112, 0, 112, 136, 16, 96] }, // ぅ
    12358: { w: 6, h: 8, b: [120, 0, 120, 132, 4, 4, 8, 112] }, // う
    12359: { w: 5, h: 6, b: [112, 0, 240, 32, 96, 184] }, // ぇ
    12360: { w: 7, h: 8, b: [56, 0, 124, 8, 16, 56, 72, 142] }, // え
    12361: { w: 6, h: 6, b: [32, 244, 32, 120, 164, 104] }, // ぉ
    12362: { w: 7, h: 8, b: [32, 244, 34, 32, 60, 98, 162, 108] }, // お
    12363: { w: 7, h: 8, b: [32, 32, 244, 42, 74, 72, 72, 176] }, // か
    12364: { w: 7, h: 10, b: [10, 10, 32, 32, 244, 42, 74, 72, 72, 176] }, // が
    12365: { w: 7, h: 8, b: [16, 124, 8, 254, 4, 60, 64, 60] }, // き
    12366: { w: 7, h: 10, b: [10, 10, 16, 124, 8, 254, 4, 60, 64, 60] }, // ぎ
    12367: { w: 4, h: 8, b: [16, 32, 64, 128, 128, 64, 32, 16] }, // く
    12368: { w: 6, h: 10, b: [20, 20, 16, 32, 64, 128, 128, 64, 32, 16] }, // ぐ
    12369: { w: 7, h: 8, b: [132, 132, 190, 132, 132, 132, 136, 16] }, // け
    12370: { w: 7, h: 10, b: [10, 10, 132, 132, 190, 132, 132, 132, 136, 16] }, // げ
    12371: { w: 7, h: 7, b: [124, 0, 0, 0, 64, 128, 126] }, // こ
    12372: { w: 7, h: 10, b: [10, 10, 0, 124, 0, 0, 0, 64, 128, 126] }, // ご
    12373: { w: 7, h: 8, b: [16, 254, 8, 4, 124, 128, 64, 56] }, // さ
    12374: { w: 7, h: 10, b: [10, 10, 16, 254, 8, 4, 124, 128, 64, 56] }, // ざ
    12375: { w: 6, h: 8, b: [128, 128, 128, 128, 128, 132, 136, 112] }, // し
    12376: { w: 6, h: 10, b: [20, 20, 128, 128, 128, 128, 128, 132, 136, 112] }, // じ
    12377: { w: 7, h: 8, b: [16, 254, 16, 56, 72, 56, 8, 48] }, // す
    12378: { w: 7, h: 10, b: [10, 10, 16, 254, 16, 56, 72, 56, 8, 48] }, // ず
    12379: { w: 7, h: 8, b: [36, 36, 254, 36, 44, 32, 32, 30] }, // せ
    12380: { w: 7, h: 10, b: [10, 10, 36, 36, 254, 36, 44, 32, 32, 30] }, // ぜ
    12381: { w: 7, h: 8, b: [124, 16, 32, 254, 16, 32, 32, 28] }, // そ
    12382: { w: 7, h: 10, b: [10, 10, 124, 16, 32, 254, 16, 32, 32, 28] }, // ぞ
    12383: { w: 7, h: 8, b: [32, 240, 46, 64, 64, 72, 144, 142] }, // た
    12384: { w: 7, h: 10, b: [10, 10, 32, 240, 46, 64, 64, 72, 144, 142] }, // だ
    12385: { w: 7, h: 8, b: [32, 252, 32, 92, 98, 2, 4, 56] }, // ち
    12386: { w: 7, h: 10, b: [10, 10, 32, 252, 32, 92, 98, 2, 4, 56] }, // ぢ
    12387: { w: 6, h: 5, b: [56, 196, 4, 8, 48] }, // っ
    12388: { w: 7, h: 6, b: [60, 194, 2, 2, 4, 56] }, // つ
    12389: { w: 7, h: 9, b: [10, 10, 0, 60, 194, 2, 2, 4, 56] }, // づ
    12390: { w: 7, h: 7, b: [254, 16, 32, 32, 32, 16, 12] }, // て
    12391: { w: 7, h: 10, b: [10, 10, 0, 254, 16, 32, 32, 32, 16, 12] }, // で
    12392: { w: 7, h: 8, b: [32, 32, 36, 56, 64, 128, 128, 126] }, // と
    12393: { w: 7, h: 10, b: [10, 10, 32, 32, 36, 56, 64, 128, 128, 126] }, // ど
    12394: { w: 7, h: 8, b: [32, 244, 34, 68, 68, 156, 38, 24] }, // な
    12395: { w: 7, h: 8, b: [128, 156, 128, 128, 128, 144, 160, 158] }, // に
    12396: { w: 7, h: 8, b: [8, 72, 92, 106, 170, 182, 170, 70] }, // ぬ
    12397: { w: 7, h: 8, b: [32, 44, 242, 34, 34, 102, 170, 38] }, // ね
    12398: { w: 7, h: 7, b: [56, 84, 146, 146, 162, 68, 24] }, // の
    12399: { w: 7, h: 8, b: [132, 132, 190, 132, 132, 156, 166, 152] }, // は
    12400: { w: 7, h: 10, b: [10, 10, 132, 132, 190, 132, 132, 156, 166, 152] }, // ば
    12401: { w: 7, h: 11, b: [4, 10, 4, 132, 132, 190, 132, 132, 156, 166, 152] }, // ぱ
    12402: { w: 7, h: 8, b: [232, 36, 70, 132, 132, 132, 72, 48] }, // ひ
    12403: { w: 7, h: 10, b: [10, 10, 232, 36, 70, 132, 132, 132, 72, 48] }, // び
    12404: { w: 7, h: 11, b: [4, 10, 4, 232, 36, 70, 132, 132, 132, 72, 48] }, // ぴ
    12405: { w: 7, h: 8, b: [48, 8, 16, 16, 76, 74, 138, 48] }, // ふ
    12406: { w: 7, h: 10, b: [10, 10, 48, 8, 16, 16, 76, 74, 138, 48] }, // ぶ
    12407: { w: 7, h: 11, b: [4, 10, 4, 48, 8, 16, 16, 76, 74, 138, 48] }, // ぷ
    12408: { w: 7, h: 6, b: [32, 80, 80, 136, 4, 2] }, // へ
    12409: { w: 7, h: 9, b: [10, 10, 0, 32, 80, 80, 136, 4, 2] }, // べ
    12410: { w: 7, h: 10, b: [4, 10, 4, 0, 32, 80, 80, 136, 4, 2] }, // ぺ
    12411: { w: 7, h: 8, b: [190, 132, 190, 132, 132, 156, 166, 152] }, // ほ
    12412: { w: 7, h: 10, b: [10, 10, 190, 132, 190, 132, 132, 156, 166, 152] }, // ぼ
    12413: { w: 7, h: 11, b: [4, 10, 4, 190, 132, 190, 132, 132, 156, 166, 152] }, // ぽ
    12414: { w: 7, h: 8, b: [16, 254, 16, 254, 16, 120, 148, 98] }, // ま
    12415: { w: 7, h: 8, b: [112, 16, 20, 60, 102, 164, 164, 72] }, // み
    12416: { w: 7, h: 8, b: [32, 244, 34, 96, 160, 162, 66, 60] }, // む
    12417: { w: 7, h: 8, b: [8, 72, 92, 106, 170, 178, 162, 76] }, // め
    12418: { w: 7, h: 8, b: [16, 252, 32, 252, 32, 34, 34, 28] }, // も
    12419: { w: 6, h: 6, b: [144, 120, 196, 72, 32, 32] }, // ゃ
    12420: { w: 7, h: 8, b: [72, 92, 226, 34, 36, 32, 16, 16] }, // や
    12421: { w: 6, h: 7, b: [16, 184, 212, 148, 184, 16, 32] }, // ゅ
    12422: { w: 7, h: 8, b: [16, 188, 202, 138, 170, 156, 16, 32] }, // ゆ
    12423: { w: 6, h: 6, b: [16, 28, 16, 112, 152, 100] }, // ょ
    12424: { w: 7, h: 8, b: [16, 16, 30, 16, 16, 120, 148, 98] }, // よ
    12425: { w: 7, h: 8, b: [112, 8, 64, 124, 194, 130, 4, 56] }, // ら
    12426: { w: 5, h: 8, b: [176, 200, 136, 136, 136, 8, 16, 96] }, // り
    12427: { w: 7, h: 8, b: [124, 16, 32, 124, 130, 50, 74, 60] }, // る
    12428: { w: 7, h: 8, b: [32, 44, 244, 36, 36, 100, 166, 36] }, // れ
    12429: { w: 7, h: 8, b: [124, 16, 32, 124, 130, 2, 4, 56] }, // ろ
    12430: { w: 6, h: 6, b: [64, 216, 100, 68, 196, 88] }, // ゎ
    12431: { w: 7, h: 8, b: [32, 44, 242, 34, 34, 98, 162, 44] }, // わ
    12432: { w: 7, h: 8, b: [112, 16, 28, 50, 82, 150, 170, 70] }, // ゐ
    12433: { w: 7, h: 8, b: [124, 16, 56, 68, 24, 32, 108, 146] }, // ゑ
    12434: { w: 7, h: 8, b: [16, 252, 32, 118, 152, 40, 64, 62] }, // を
    12435: { w: 7, h: 8, b: [16, 16, 32, 32, 112, 72, 138, 140] }, // ん
    12449: { w: 5, h: 5, b: [248, 40, 48, 32, 64] }, // ァ
    12450: { w: 7, h: 8, b: [254, 2, 20, 24, 16, 16, 32, 64] }, // ア
    12451: { w: 5, h: 6, b: [8, 16, 48, 208, 16, 16] }, // ィ
    12452: { w: 7, h: 8, b: [2, 4, 8, 24, 40, 200, 8, 8] }, // イ
    12453: { w: 5, h: 6, b: [32, 248, 136, 8, 16, 96] }, // ゥ
    12454: { w: 7, h: 8, b: [16, 254, 130, 130, 4, 4, 8, 48] }, // ウ
    12455: { w: 5, h: 5, b: [112, 32, 32, 32, 248] }, // ェ
    12456: { w: 7, h: 6, b: [124, 16, 16, 16, 16, 254] }, // エ
    12457: { w: 5, h: 6, b: [16, 248, 48, 80, 144, 48] }, // ォ
    12458: { w: 7, h: 8, b: [8, 254, 8, 24, 40, 72, 136, 24] }, // オ
    12459: { w: 7, h: 8, b: [16, 254, 18, 18, 34, 34, 74, 132] }, // カ
    12460: { w: 7, h: 10, b: [10, 10, 16, 254, 18, 18, 34, 34, 74, 132] }, // ガ
    12461: { w: 7, h: 8, b: [16, 124, 16, 16, 254, 8, 8, 8] }, // キ
    12462: { w: 7, h: 10, b: [10, 10, 16, 124, 16, 16, 254, 8, 8, 8] }, // ギ
    12463: { w: 7, h: 8, b: [32, 62, 66, 130, 4, 4, 24, 96] }, // ク
    12464: { w: 7, h: 10, b: [10, 10, 32, 62, 66, 130, 4, 4, 24, 96] }, // グ
    12465: { w: 7, h: 8, b: [64, 126, 72, 136, 8, 8, 16, 32] }, // ケ
    12466: { w: 7, h: 10, b: [10, 10, 64, 126, 72, 136, 8, 8, 16, 32] }, // ゲ
    12467: { w: 6, h: 7, b: [252, 4, 4, 4, 4, 4, 252] }, // コ
    12468: { w: 6, h: 10, b: [20, 20, 0, 252, 4, 4, 4, 4, 4, 252] }, // ゴ
    12469: { w: 7, h: 8, b: [36, 254, 36, 36, 36, 4, 8, 48] }, // サ
    12470: { w: 7, h: 10, b: [10, 10, 36, 254, 36, 36, 36, 4, 8, 48] }, // ザ
    12471: { w: 7, h: 8, b: [96, 16, 194, 34, 4, 4, 24, 96] }, // シ
    12472: { w: 7, h: 10, b: [10, 10, 96, 16, 194, 34, 4, 4, 24, 96] }, // ジ
    12473: { w: 7, h: 7, b: [124, 4, 4, 8, 24, 36, 194] }, // ス
    12474: { w: 7, h: 10, b: [10, 10, 0, 124, 4, 4, 8, 24, 36, 194] }, // ズ
    12475: { w: 7, h: 8, b: [32, 32, 254, 34, 36, 32, 32, 30] }, // セ
    12476: { w: 7, h: 10, b: [10, 10, 32, 32, 254, 34, 36, 32, 32, 30] }, // ゼ
    12477: { w: 7, h: 7, b: [130, 66, 68, 4, 8, 16, 32] }, // ソ
    12478: { w: 7, h: 10, b: [10, 10, 0, 130, 66, 68, 4, 8, 16, 32] }, // ゾ
    12479: { w: 7, h: 8, b: [32, 62, 66, 178, 12, 4, 24, 96] }, // タ
    12480: { w: 7, h: 10, b: [10, 10, 32, 62, 66, 178, 12, 4, 24, 96] }, // ダ
    12481: { w: 7, h: 8, b: [12, 112, 16, 254, 16, 16, 16, 32] }, // チ
    12482: { w: 7, h: 10, b: [10, 10, 12, 112, 16, 254, 16, 16, 16, 32] }, // ヂ
    12483: { w: 5, h: 5, b: [168, 168, 8, 16, 96] }, // ッ
    12484: { w: 7, h: 7, b: [162, 82, 82, 4, 4, 8, 48] }, // ツ
    12485: { w: 7, h: 10, b: [10, 10, 0, 162, 82, 82, 4, 4, 8, 48] }, // ヅ
    12486: { w: 7, h: 8, b: [124, 0, 254, 16, 16, 16, 16, 32] }, // テ
    12487: { w: 7, h: 10, b: [10, 10, 124, 0, 254, 16, 16, 16, 16, 32] }, // デ
    12488: { w: 4, h: 8, b: [128, 128, 128, 224, 144, 128, 128, 128] }, // ト
    12489: { w: 5, h: 10, b: [40, 40, 128, 128, 128, 224, 144, 128, 128, 128] }, // ド
    12490: { w: 7, h: 8, b: [16, 16, 254, 16, 16, 16, 32, 64] }, // ナ
    12491: { w: 7, h: 6, b: [124, 0, 0, 0, 0, 254] }, // ニ
    12492: { w: 7, h: 8, b: [124, 4, 36, 24, 8, 20, 34, 192] }, // ヌ
    12493: { w: 7, h: 8, b: [16, 124, 4, 8, 16, 52, 210, 16] }, // ネ
    12494: { w: 6, h: 8, b: [4, 4, 4, 8, 8, 16, 32, 192] }, // ノ
    12495: { w: 7, h: 7, b: [40, 36, 36, 68, 66, 66, 130] }, // ハ
    12496: { w: 7, h: 10, b: [10, 10, 0, 40, 36, 36, 68, 66, 66, 130] }, // バ
    12497: { w: 7, h: 11, b: [4, 10, 4, 0, 40, 36, 36, 68, 66, 66, 130] }, // パ
    12498: { w: 6, h: 8, b: [128, 128, 140, 240, 128, 128, 128, 124] }, // ヒ
    12499: { w: 6, h: 10, b: [20, 20, 128, 128, 140, 240, 128, 128, 128, 124] }, // ビ
    12500: { w: 6, h: 11, b: [8, 20, 8, 128, 128, 140, 240, 128, 128, 128, 124] }, // ピ
    12501: { w: 7, h: 7, b: [254, 2, 4, 4, 8, 16, 96] }, // フ
    12502: { w: 7, h: 10, b: [10, 10, 0, 254, 2, 4, 4, 8, 16, 96] }, // ブ
    12503: { w: 7, h: 11, b: [4, 10, 4, 0, 254, 2, 4, 4, 8, 16, 96] }, // プ
    12504: { w: 7, h: 6, b: [32, 80, 72, 136, 4, 2] }, // ヘ
    12505: { w: 7, h: 9, b: [10, 10, 0, 32, 80, 72, 136, 4, 2] }, // ベ
    12506: { w: 7, h: 10, b: [4, 10, 4, 0, 32, 80, 72, 136, 4, 2] }, // ペ
    12507: { w: 7, h: 8, b: [16, 254, 16, 16, 84, 146, 16, 48] }, // ホ
    12508: { w: 7, h: 10, b: [10, 10, 16, 254, 16, 16, 84, 146, 16, 48] }, // ボ
    12509: { w: 7, h: 11, b: [4, 10, 4, 16, 254, 16, 16, 84, 146, 16, 48] }, // ポ
    12510: { w: 7, h: 7, b: [254, 2, 4, 72, 48, 16, 8] }, // マ
    12511: { w: 6, h: 8, b: [112, 8, 0, 112, 8, 0, 224, 28] }, // ミ
    12512: { w: 7, h: 8, b: [16, 16, 32, 32, 32, 72, 68, 250] }, // ム
    12513: { w: 6, h: 8, b: [4, 4, 100, 24, 8, 20, 36, 192] }, // メ
    12514: { w: 7, h: 8, b: [124, 32, 32, 254, 32, 32, 32, 30] }, // モ
    12515: { w: 6, h: 6, b: [32, 60, 228, 32, 16, 16] }, // ャ
    12516: { w: 7, h: 8, b: [32, 62, 226, 36, 32, 16, 16, 16] }, // ヤ
    12517: { w: 6, h: 5, b: [112, 16, 16, 16, 252] }, // ュ
    12518: { w: 7, h: 6, b: [120, 8, 8, 8, 8, 254] }, // ユ
    12519: { w: 4, h: 5, b: [240, 16, 112, 16, 240] }, // ョ
    12520: { w: 6, h: 8, b: [252, 4, 4, 124, 4, 4, 4, 252] }, // ヨ
    12521: { w: 7, h: 8, b: [124, 0, 254, 2, 2, 4, 8, 48] }, // ラ
    12522: { w: 5, h: 8, b: [136, 136, 136, 136, 136, 8, 16, 96] }, // リ
    12523: { w: 7, h: 8, b: [8, 40, 40, 40, 42, 74, 76, 136] }, // ル
    12524: { w: 5, h: 8, b: [128, 128, 128, 128, 136, 144, 160, 192] }, // レ
    12525: { w: 6, h: 7, b: [252, 132, 132, 132, 132, 132, 252] }, // ロ
    12526: { w: 5, h: 5, b: [248, 136, 8, 16, 96] }, // ヮ
    12527: { w: 7, h: 7, b: [254, 130, 130, 4, 4, 8, 48] }, // ワ
    12528: { w: 7, h: 8, b: [8, 254, 72, 72, 72, 254, 8, 8] }, // ヰ
    12529: { w: 7, h: 6, b: [124, 4, 8, 16, 16, 254] }, // ヱ
    12530: { w: 6, h: 8, b: [252, 4, 4, 124, 8, 8, 16, 96] }, // ヲ
    12531: { w: 7, h: 7, b: [192, 34, 2, 4, 8, 48, 192] }, // ン
    12532: { w: 7, h: 10, b: [10, 10, 16, 254, 130, 130, 4, 4, 8, 48] }, // ヴ
    12533: { w: 5, h: 6, b: [32, 248, 40, 72, 72, 152] }, // ヵ
    12534: { w: 6, h: 6, b: [64, 124, 144, 16, 16, 32] }, // ヶ
};

export function generateJpFontCode(chars: string): string {
    const codes = Array.from(new Set(Array.from(chars).map((c) => c.codePointAt(0)!)))
        .filter((c) => c in JP_FONT_DB)
        .sort((a, b) => a - b);

    if (codes.length === 0) return '';

    const bitmapBytes: number[] = [];
    const glyphEntries: { code: number; offset: number; w: number; h: number }[] = [];
    let offset = 0;

    for (const code of codes) {
        const g = JP_FONT_DB[code];
        glyphEntries.push({ code, offset, w: g.w, h: g.h });
        bitmapBytes.push(...g.b);
        offset += g.b.length;
    }

    const bitmapStr = bitmapBytes
        .map((b, i) => (i % 12 === 0 ? '\n  ' : '') + `0x${b.toString(16).toUpperCase().padStart(2, '0')}`)
        .join(', ');

    // グリフテーブル: [offsetLo, offsetHi, width, height] 4バイト/文字
    const glyphTableStr = glyphEntries
        .map((ge) => `  ${ge.offset & 0xff}, ${(ge.offset >> 8) & 0xff}, ${ge.w}, ${ge.h}`)
        .join(',\n');

    const lookupStr = glyphEntries
        .map((ge, i) => `{ 0x${ge.code.toString(16).toUpperCase().padStart(4, '0')}, ${i} }`)
        .join(', ');

    return [
        `#ifdef ESP32`,
        `const uint8_t _oledJpBmp[] = {${bitmapStr}\n};`,
        `const uint8_t _oledJpGlyphs[] = {\n${glyphTableStr}\n};`,
        `struct _OledJpLk { uint16_t c; uint8_t i; };`,
        `const _OledJpLk _oledJpLk[] = { ${lookupStr} };`,
        `#else`,
        `const uint8_t _oledJpBmp[] PROGMEM = {${bitmapStr}\n};`,
        `const uint8_t _oledJpGlyphs[] PROGMEM = {\n${glyphTableStr}\n};`,
        `struct _OledJpLk { uint16_t c; uint8_t i; };`,
        `const _OledJpLk _oledJpLk[] PROGMEM = { ${lookupStr} };`,
        `#endif`,
        `const uint8_t _oledJpLkLen = ${glyphEntries.length};`,
    ].join('\n');
}
